import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { auth, db } from "../firebase";
import { doc, setDoc } from "firebase/firestore";
import "../App.css";
import TopNav from "../components/TopNav";

function Register() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
    age: "",
    gender: "",
    phone: "",
    area: "",
  });
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setErrorMsg("");
    setLoading(true);

    if (form.password !== form.confirmPassword) {
      setErrorMsg("Passwords do not match.");
      setLoading(false);
      return;
    }

    try {
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        form.email,
        form.password
      );

      const userId = userCredential.user.uid;
      await setDoc(doc(db, "users", userId), {
        name: form.name,
        email: form.email,
        age: form.age,
        gender: form.gender,
        phone: form.phone,
        area: form.area,
        createdAt: new Date(),
      });

      navigate("/");
    } catch (err) {
      const errorCode = err.code;
      if (errorCode === "auth/email-already-in-use") {
        setErrorMsg("This email is already registered.");
      } else if (errorCode === "auth/weak-password") {
        setErrorMsg("Password should be at least 6 characters.");
      } else {
        setErrorMsg("Registration failed. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <TopNav />
      <div className="login_section">
        <h1 className="auth-heading">Register on WorkMart</h1>
        <p className="auth-subtext">Create your account to get started</p>

        <form onSubmit={handleRegister} className="auth-form">
          <input
            type="text"
            name="name"
            placeholder="Full Name"
            value={form.name}
            onChange={handleChange}
            required
          />
          <input
            type="email"
            name="email"
            placeholder="Email"
            value={form.email}
            onChange={handleChange}
            required
          />
          <input
            type="password"
            name="password"
            placeholder="Password (6+ characters)"
            value={form.password}
            onChange={handleChange}
            required
          />
          <input
            type="password"
            name="confirmPassword"
            placeholder="Confirm Password"
            value={form.confirmPassword}
            onChange={handleChange}
            required
          />

          <input
            type="number"
            name="age"
            className="date_picker_register"
            value={form.age || ""}
            onChange={(e) => setForm({ ...form, age: e.target.value })}
            placeholder="Age"
            min="0"
            max="120"
            required
          />

          <select
            name="gender"
            value={form.gender}
            onChange={handleChange}
            required
          >
            <option value="">Select Gender</option>
            <option value="male">Male</option>
            <option value="female">Female</option>
            <option value="other">Other</option>
          </select>
          <input
            type="tel"
            name="phone"
            placeholder="Phone Number"
            value={form.phone}
            onChange={handleChange}
            required
          />
          <input
            type="text"
            name="area"
            placeholder="Living Area"
            value={form.area}
            onChange={handleChange}
            required
          />

          {errorMsg && <p className="error-text">{errorMsg}</p>}

          <button
            className="auth-btn login_btn"
            type="submit"
            disabled={loading}
          >
            {loading ? <span className="loader"></span> : "Register"}
          </button>
        </form>
        <p className="auth-link">
          Don’t have an account?{" "}
          <span className="auth-link-btn" onClick={() => navigate("/login")}>
            Login Page
          </span>
        </p>
      </div>
    </div>
  );
}

export default Register;
